import React from 'react'
import { Helmet } from "react-helmet-async";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Refund Policy - Myomnamo - Spiritual Services Platform</title>
        <meta
          name="description"
          content="Read our Privacy Policy to understand how we protect your data. Learn about information collection, usage, and your rights as a user."
        />

        {/* Canonical Tag */}
        <link rel="canonical" href="https://www.Myomnamo.com/privacy-policy" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Privacy Policy - Myomnamo - Spiritual Services Platform"
        />
        <meta
          property="og:description"
          content="Read our Privacy Policy to understand how we protect your data. Learn about information collection, usage, and your rights as a user."
        />
        <meta
          property="og:image"
          content="https://www.Myomnamo.com/assets/images/new/logo.png"
        />
        <meta
          property="og:url"
          content="https://www.Myomnamo.com/privacy-policy"
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Privacy Policy - Myomnamo - Spiritual Services Platform"
        />
        <meta
          name="twitter:description"
          content="Read our Privacy Policy to understand how we protect your data. Learn about information collection, usage, and your rights as a user."
        />
        <meta
          name="twitter:image"
          content="https://www.Myomnamo.com/assets/images/new/logo.png"
        />

        {/* Schema Markup - Breadcrumb List */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.Myomnamo.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Privacy Policy",
                item: "https://www.Myomnamo.com/privacy-policy",
              },
            ],
          })}
        </script>

        {/* Schema Markup - WebPage */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebPage",
            name: "Privacy Policy - Myomnamo - Spiritual Services Platform",
            url: "https://www.Myomnamo.com/privacy-policy",
            description:
              "Read our Privacy Policy to understand how we protect your data. Learn about information collection, usage, and your rights as a user.",
            publisher: {
              "@type": "Organization",
              name: "Myomnamo",
            },
          })}
        </script>
      </Helmet>

      <div
        className="container mx-auto p-6 mt-5"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <h3 className="text-2xl font-bold mb-4">
          Refund Policy for Myomnamo
        </h3>
        <p className="mb-4">
          Welcome to Myomnamo We are committed to providing you with the best spiritual services. Please read our refund policy carefully to understand your rights and obligations regarding purchases made through our website (
          <a href="https://www.myomnamo.com" className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">
            www.myomnamo.com
          </a>
          ).
        </p>

        <h4>1. Eligibility for Refunds</h4>
        <p>Refunds may be issued under the following conditions:</p>
        <ul>
          <li>The transaction was made in error.</li>
          <li>he product/service purchased is unavailable or could not be delivered.</li>
          <li>The service/product received is significantly different from its description.</li>
          <li>Duplicate or unauthorized transactions.</li>
        </ul>

        <h4 className="mt-4">2. Timeframe for Refund Requests</h4>
        <p>You must submit a refund request within <strong>3 days</strong> from the date of the transaction. After this period, refund requests may not be accepted.</p>

        <h4 className="mt-4">3. How to Request a Refund</h4>
        <p>To request a refund, please contact us at:</p>
        <ul>
          <li>📧 Email: <a href="mailto:info@myomnamo.com">info@myomnamo.com</a></li>
          <li>📞 Phone: <a href="tel:+917738581133">+91 7738581133</a></li>
        </ul>
        <p>📝 Provide the following details:</p>
        <ul>
          <li>Name</li>
          <li>Registered Mobile Number</li>
          <li>Transaction ID</li>
          <li>Date of Transaction</li>
          <li>Reason for Refund</li>
        </ul>

        <h4 className="mt-4">4. Refund Process</h4>
        <p>Once your request is received and verified, we will initiate a refund via <strong>PhonePe</strong> .</p>
        <p>Return/Exchange Period: Varies between <strong>1 to 2 days</strong>, depending on the merchant and product category. </p>
        <p>If return/exchange is approved it will be returned/exchanged in 7-10 days</p>
        <p>Refunds will be credited within <strong>7-10 business days</strong>.</p>
        <p>You will receive a confirmation once the refund has been issued.</p>

        <h4 className="mt-4">5. Delivery Process Process</h4>
        <p>Will deliver your product within 8-10 Day's.</p>


        <h4 className="mt-4">6. Non-Refundable Situations</h4>
        <ul>
          <li>Change of mind after a successful transaction.</li>
          <li>Failure to read the product/service description.</li>
          <li>Requests submitted beyond the eligible refund window.</li>
        </ul>

        <h4 className="mt-4">7. Dispute Resolution</h4>
        <p>If you have any disputes regarding transactions or refunds, please reach out to us first. If unresolved, you may contact PhonePe customer support for further assistance.</p>

        <h4 className="mt-4">8. Policy Updates</h4>
        <p>We may update this Refund Policy from time to time. Changes will be posted within the app or on our website with an updated “Effective Date.”</p>
      </div>
    </>
  );
};

export default RefundPolicy